// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__27msb","icon":"styles_icon__XcLFB"};